
export default {
  name: 'Diy2BannerSkeleton'
}
